import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get('list-selectors-for-change-student-application')
}
